// extracted by mini-css-extract-plugin
export var columnList = "_bs-0";